import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { rankingList } from "@/mocks/anime";

const rankTabs = ["综合榜", "番剧榜", "剧场版 / OVA榜"];

const trendIcon: Record<string, { icon: string; className: string; label: string }> = {
  up: { icon: "ri-arrow-up-line", className: "text-primary-600 bg-primary-100", label: "上升" },
  down: { icon: "ri-arrow-down-line", className: "text-secondary-700 bg-secondary-100", label: "下降" },
  flat: { icon: "ri-subtract-line", className: "text-foreground-500 bg-background-200", label: "持平" },
};

export default function Ranking() {
  const [tab, setTab] = useState("综合榜");

  const list = rankingList.filter((item) => {
    if (tab === "综合榜") return true;
    if (tab === "番剧榜") return !item.genre.includes("剧场版");
    return item.genre.includes("剧场版");
  });

  return (
    <section id="ranking" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <SectionHeading
          eyebrow="口碑与热度"
          icon="ri-bar-chart-2-line"
          title="排行榜 · 近期讨论度与口碑参考"
          description="榜单按综合热度与口碑排序，趋势标记表示最近讨论度的变化方向：上升、下降或持平。榜单只作浏览参考，找到合口味的作品才是重点。"
        />
        <div className="flex gap-1 p-1 rounded-full bg-background-50 border border-background-200/70 mb-8 md:mb-10 shrink-0 self-start lg:self-auto">
          {rankTabs.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setTab(item)}
              aria-pressed={tab === item}
              className={`px-3 md:px-4 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
                tab === item ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      <div className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
        {list.map((item, index) => {
          const trend = trendIcon[item.trend];
          return (
            <div
              key={item.title}
              className={`flex items-center gap-3 md:gap-5 px-4 md:px-6 py-3.5 hover:bg-primary-50 transition-colors ${
                index !== list.length - 1 ? "border-b border-background-200/60" : ""
              }`}
            >
              <span
                className={`w-7 md:w-8 shrink-0 text-center font-heading text-lg md:text-xl font-bold ${
                  item.rank <= 3 ? "text-primary-600" : "text-foreground-400"
                }`}
              >
                {item.rank}
              </span>
              <div className="w-11 h-14 md:w-12 md:h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} 封面`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 truncate">{item.genre}</p>
              </div>
              <span className="hidden sm:flex items-center gap-1 text-xs">
                <span className={`w-6 h-6 flex items-center justify-center rounded-full ${trend.className}`}>
                  <i className={trend.icon} aria-hidden="true"></i>
                </span>
                <span className="text-foreground-500">{trend.label}</span>
              </span>
              <span className="shrink-0 flex items-center gap-1 font-semibold text-primary-700 text-sm md:text-base">
                <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
                {item.score.toFixed(1)}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}